var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"btn-group"},[_vm._m(0),_c('WxOpen')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"float-wrap"},[_c('div',{staticClass:"float-logo-wrap"},[_c('img',{staticClass:"float-logo",attrs:{"src":require("../assets/img/img_share_logo_s.png"),"alt":""}})]),_c('div',{staticClass:"float-text"},[_vm._v("打开App")])])
}]

export { render, staticRenderFns }